export const searchFormOption = function () {
  return [
    {
      prop: "keyword",
      label: "关键字",
      type: "input",
      placeholder: "请输入车架号/车牌号",
      width: "20%",
    },
    {
      prop: "dateList",
      label: "提交时间",
      type: "range-date",
      width: "20%",
    },
	{
	  prop: "billDateList",
	  label: "出单时间",
	  type: "range-date",
	  width: "20%",
	},
    {
      prop: "orgNo",
      label: "出单机构",
      type: "cascader",
      placeholder: "请选择内容",
      propConfig: {
        children: "children",
        label: "orgName",
        value: "id",
        checkStrictly: true,
        emitPath: false,
      },
      options: this.$store.state.app.orgList,
      width: "20%",
    },
    {
      prop: "saleNo",
      label: "业务员",
      type: "select",
      width: "20%",
      options: this.$store.state.app.salesmanList,
    },
	{
	  prop: "creatorNo",
	  label: "制单员",
	  type: "select",
	  width: "20%",
	  options: this.creatorNoList,
	},
    {
      prop: "status",
      label: "状态",
      type: "select",
      width: "20%",
      options: this.$emun.status,
    },
  ];
};
export const cashFormOption = function() {
    return [
      {
        prop: 'taxPoint',
        label: '税费',
        type: 'input',
        placeholder: '请输入税费'
      },
      {
        prop: 'isInvoice',
        label: '是否开票',
        type: 'radio',
        options: [
            {
                label: '专票',
                value: 1
            },
			{
			    label: '普票',
			    value: 2
			},
            {
                label: '否',
                value: 0
            }
        ]
      }
    ]
  };

export default {};
